module.exports = require("../vinyl/duplexify.js");